import { koliPairs } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import SizeMatrix from "@/components/SizeMatrix";
import { X, ChevronDown, ChevronUp } from "lucide-react";

export const sel = "h-10 bg-[#FFFBF4] border-[#DCCFB8]";
export const content = "bg-[#FFFBF4] border-[#DCCFB8] text-[#2B2118]";
export const cols = "sm:grid-cols-[minmax(0,1fr)_minmax(0,1fr)_80px_90px_28px_20px]";
const grid = `grid grid-cols-2 ${cols} gap-2 items-center`;
const pairsOf = (l) => Object.values(l.sizes).reduce((a, b) => a + (parseInt(b) || 0), 0);
const sizeText = (sizes) => Object.entries(sizes).filter(([, q]) => parseInt(q) > 0).map(([s, q]) => `${s}×${q}`).join(" · ");

const ColorSelect = ({ p, i, l, opts, onUpdate }) => (
  <Select value={l.product_id} onValueChange={(v) => onUpdate(l.id, { product_id: v })}>
    <SelectTrigger data-testid={`${p}-color-${i}`} className={`${sel} col-span-2 sm:col-span-1`}><SelectValue placeholder="Renk seçin..." /></SelectTrigger>
    <SelectContent className={content}>
      {opts.length === 0 && <div className="px-3 py-2 text-sm text-[#8C7B68]">Başka renk yok</div>}
      {opts.map((c) => <SelectItem key={c.id} value={c.id} data-testid={`${p}-color-${i}-option-${c.id}`}>{c.model_color}</SelectItem>)}
    </SelectContent>
  </Select>
);

const KoliTypeSelect = ({ p, i, typeId, koliTypes, onChange }) => (
  <Select value={typeId} onValueChange={onChange}>
    <SelectTrigger data-testid={`${p}-${i}-koli-type`} className={`${sel} min-w-0 [&>span]:truncate`}><SelectValue placeholder="Koli tipi" /></SelectTrigger>
    <SelectContent className={content}>
      {koliTypes.map((k) => <SelectItem key={k.id} value={k.id} data-testid={`${p}-${i}-koli-type-option-${k.id}`}>{k.name} ({koliPairs(k.ratios)} çift)</SelectItem>)}
    </SelectContent>
  </Select>
);

// One color row of a model block: color, koli type, koli count, pairs and size editor
export const ModelColorLine = ({ p, i, l, opts, koliTypes, open, onToggle, onUpdate, onUpdateSize, setKoli, onRemove, extra }) => {
  const typeId = l.koli_type_id || koliTypes[0]?.id || "";
  const pairs = pairsOf(l);
  return (
    <div data-testid={`${p}-color-row-${i}`}>
      <div className={grid}>
        <ColorSelect p={p} i={i} l={l} opts={opts} onUpdate={onUpdate} />
        <KoliTypeSelect p={p} i={i} typeId={typeId} koliTypes={koliTypes} onChange={(v) => setKoli(l, v, l.koli_count)} />
        <Input type="number" min={0} inputMode="numeric" placeholder="Koli" value={l.koli_count}
          onChange={(e) => setKoli(l, typeId, e.target.value)} data-testid={`${p}-${i}-koli-count`}
          className="h-10 text-center font-mono font-bold bg-[#FFFBF4] border-[#DCCFB8]" />
        <span className="text-right font-mono text-sm font-bold text-[#B45309]" data-testid={`${p}-${i}-koli-pairs`}>{pairs} çift</span>
        <button type="button" onClick={onToggle} title="Numaraları göster/düzenle"
          data-testid={`${p}-sizes-toggle-${i}`} className="text-[#6B5B4A] hover:text-[#B45309]">
          {open ? <ChevronUp className="w-4 h-4" /> : <ChevronDown className="w-4 h-4" />}
        </button>
        {onRemove
          ? <button type="button" onClick={onRemove} data-testid={`${p}-color-remove-${i}`} title="Rengi kaldır" className="text-[#8C7B68] hover:text-[#EF4444]"><X className="w-4 h-4" /></button>
          : <span />}
      </div>
      {open
        ? <div className="mt-2 rounded-md bg-[#FFFBF4]/60 p-2"><SizeMatrix values={l.sizes} onChange={(s, v) => onUpdateSize(l.id, s, v)} testIdPrefix={`${p}-size-${i}`} /></div>
        : pairs > 0 && <p className="text-[11px] font-mono text-[#8C7B68] px-1 mt-0.5" data-testid={`${p}-sizes-text-${i}`}>{sizeText(l.sizes)}</p>}
      {extra}
    </div>
  );
};
